"use client"

import { IUserInfo } from "../../../servers/usercenter/interface"
import { UserInfoContext } from "../../UserProvider"

interface UserInfoProviderWrapperProps {
  userInfo: IUserInfo | null
  children: React.ReactNode
}

/**
 * 客户端包装组件：提供 UserInfoContext
 * 用于在服务端组件中使用 UserInfoContext.Provider
 */
export function UserInfoProviderWrapper({ userInfo, children }: UserInfoProviderWrapperProps) {
  const userInfoContextValue = {
    userInfo,
    loginStatus: !!userInfo,
  }

  return <UserInfoContext.Provider value={userInfoContextValue}>{children}</UserInfoContext.Provider>
}
